import { render, staticRenderFns } from "./MerchantManagement.vue?vue&type=template&id=7887fe58&"
import script from "./MerchantManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports